import Vue from 'vue'
import moment from 'moment'

export const topTen = {
    state: {
        topTen: null,
        status: 'idle',
        groupBy: 'SHOP',
        filters: {
            lastDays: {
                type: 'radio',
                value: 30,
                text: 'Zakres',
                noReset: true,
                options: [
                    {
                        label: 'Ostatnie 7 dni',
                        value: '7'
                    },
                    {
                        label: 'Ostatnie 30 dni',
                        value: '30'
                    },
                    {
                        label: 'Ostatnie 90 dni',
                        value: '90'
                    }
                ]
            },
            type: {
                noReset: true,
                type: 'radio',
                text: 'Typ wykresu',
                value: 'AMOUNT',
                options: [
                    {
                        label: 'Wartość',
                        value: 'AMOUNT'
                    },
                    {
                        label: 'Wolumen',
                        value: 'QUANTITY'
                    }
                ]
            },
            locationIds: {
                type: 'ui-virtual-list',
                value: null,
                searcher: false,
                label: 'Wybierz sklep',
                getter: 'getDevicesShopsForSelect',
                resetFilter: 'terminalRadIds',
                disabledLinkGenerator: true
            },
            terminalRadIds: {
                type: 'ui-virtual-list',
                value: null,
                searcher: false,
                label: 'Wybierz kasę',
                getter: 'getTopTenDevices'
            },
            startDate: {
                value: null,
                type: 'range-date',
                range: 'from',
                text: 'Od',
                title: 'Data',
                groupName: 'range'
            },
            endDate: {
                value: null,
                type: 'range-date',
                range: 'to',
                text: 'Do',
                groupName: 'range'
            }
        },
        pagination: {
            page: '1',
            nextPage: '',
            prevPage: '',
            perPage: 10,
            totalPages: 0,
            totalRecords: null
        }
    },
    mutations: {
        SET_TOPTEN(state, payload) {
            state.topTen = payload
        },
        SET_TOPTEN_STATUS(state, payload) {
            state.status = payload
        },
        SET_TOPTEN_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_TOPTEN_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_TOPTEN_GROUPBY(state, payload) {
            Vue.set(state, 'groupBy', payload)
        },
        SET_TOPTEN_PAGINATION(state, payload) {
            state.pagination = payload
        }
    },
    actions: {
        topTenFetch({ commit, state, getters }) {
            commit('SET_TOPTEN_STATUS', 'loading')

            const params = {
                userId: getters.userId,
                locationIds: state.filters.locationIds.value
                    ? [state.filters.locationIds.value]
                    : null,
                dateFrom: state.filters.startDate.value
                    ? moment(state.filters.startDate.value).format(
                        'YYYY-MM-DD HH:mm:ss'
                    )
                    : '',
                dateTo: state.filters.endDate.value
                    ? moment(state.filters.endDate.value).format(
                        'YYYY-MM-DD HH:mm:ss'
                    )
                    : '',
                type: state.filters.type.value,
                dataForAllDevices: true,
                terminalRadIds: state.filters.terminalRadIds.value
                    ? [state.filters.terminalRadIds.value]
                    : null,
                groupingType: state.groupBy,
                productLimit: 100
            }

            this.$api
                .post('statistics/topTen', params)
                .then(res => {
                    commit('SET_TOPTEN', res.data.data)
                    commit('SET_TOPTEN_PAGINATION', {
                        page: '1',
                        nextPage:
                            res.data.data.length > state.pagination.perPage
                                ? 2
                                : '',
                        prevPage: '',
                        totalPages: Math.ceil(
                            res.data.data.length / state.pagination.perPage
                        ),
                        perPage: state.pagination.perPage,
                        totalRecords: res.data.data.length
                    })
                    commit('SET_TOPTEN_STATUS', 'idle')
                })
                .catch(error => {
                    console.log(error)
                    commit('SET_TOPTEN_STATUS', 'idle')
                })
        },
        setTopTenGroupBy({ commit }, payload) {
            commit('SET_TOPTEN_GROUPBY', payload)
        },
        setTopTenPagination({ commit }, payload) {
            commit('SET_TOPTEN_PAGINATION', payload)
        }
    },
    getters: {
        getTopTen: state => {
            if (state.topTen) {
                return state.topTen
            }
        },
        getTopTenForChart: state => {
            if (state.topTen) {
                const topTen = state.topTen
                const chartType = state.filters.type.value.toLowerCase()
                return {
                    chartType: 'bar',
                    offsetX: 20,
                    series: [
                        {
                            name:
                                chartType === 'amount'
                                    ? 'Wartość sprzedaży:'
                                    : 'Wolumen sprzedaży:',
                            data: topTen
                                .slice(
                                    (state.pagination.page - 1) *
                                        state.pagination.perPage,
                                    state.pagination.page *
                                        state.pagination.perPage
                                )
                                .map(el => el.value)
                        }
                    ],
                    yaxis: {
                        title: {
                            text: ''
                        },
                        labels: {
                            offsetX: 15,
                            align: 'left'
                        }
                    },
                    categories: topTen
                        .slice(
                            (state.pagination.page - 1) *
                                state.pagination.perPage,
                            state.pagination.page * state.pagination.perPage
                        )
                        .map(
                            (el, idx) =>
                                `${idx +
                                    (state.pagination.page - 1) *
                                        state.pagination.perPage +
                                    1}. ${el.name}`
                        ),
                    categoriesTitle: 'Produkty'
                }
            }
        },
        getTopTenForFilters: state => {
            if (state.topTen) {
                return state.topTen.map(item => {
                    return { value: item.id, label: item.name }
                })
            }
        },
        getTopTenFilters: state => {
            return state.filters
        },
        getTopTenDevices: (state, getters) => {
            if (state.filters.locationIds.value) {
                const devices = []
                getters.getDevices
                    .find(
                        el => el.location_id === state.filters.locationIds.value
                    )
                    .devices.forEach(elem => {
                        devices.push({
                            label: `${elem.unique_number} - ${elem.mcuid}`,
                            value: elem.mcuid
                        })
                    })
                return devices
            }
        },
        getTopTenGroupBy: state => {
            return state.groupBy
        },
        getTopTenStatus: state => state.status,
        getTopTenPagination: state => state.pagination
    }
}
